import PropTypes from "prop-types";
import React, { useState } from "react";
import { setActiveLayout } from "../../helpers/product";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
//import { BorderColor } from "@mui/icons-material";

const ShopTopAction = ({
  getLayout,
  getFilterSortParams,
  productCount,
  sortedProductCount,
  offset,
  userData,
  query,
  getSortParams,
  setSortValues,
  sortValues,
}) => {
  const history = useHistory();
  //const location = window.location.pathname
  //const query = new URLSearchParams(location.search);
  //console.log(location)
  //const name = query.get('name')
  const [outlet, setOutlet] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.tag?.includes("OUTLET")
  );
  const [school, setSchool] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.tag?.includes("SCHOOL")
  );
  const [promo, setPromo] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.promo?.includes("SI")
  );
  const filterProducts = () => {
    var queryText = document.getElementById("queryTextShopNew");
    var iTipoRicerca = 1;
    switch (iTipoRicerca) {
      case 1:
        var queryText = queryText?.value;

        history.push("/redirect");
        setTimeout(
          () =>
            history.push(
              process.env.PUBLIC_URL + "/shop-grid-full-width?name=" + queryText
            ),
          10
        );
    }
  };

  function resetFiltri() {
    //history.push(process.env.PUBLIC_URL + "/shop-grid-full-width");

    /* OLD RESETTA FILTRI*/
    sessionStorage.setItem("filter", JSON.stringify({}));
    setSortValues({});
    history.push("/redirect");
    setTimeout(
      () => history.push(process.env.PUBLIC_URL + "/shop-grid-full-width"),
      10
    );
    localStorage.setItem("currentPage", 1);
  }

  return (
    <div className="shop-top-bar">
      <div className="select-shoing-wrap" style={{ width: "100%" }}>
        {global.aziendaID == 1 && (
          <div
            className="sidebar-widget sidebar-widget-tag"
            style={{ marginRight: "20px", marginBottom: "10px" }}
          >
            <ul>
              <li key={2}>
                <button
                  className={school ? "active" : ""}
                  style={{
                    border: "none",
                    backgroundColor: school ? "#0056b3" : "#007BFF",
                    color: school ? "white" : "white",
                    borderRadius: "50px",
                    fontSize: "20px",
                    padding: "5px 20px",
                  }}
                  onClick={(e) => {
                    localStorage.setItem("currentPage", 1);
                    if (school) {
                      setSchool(false);
                      getSortParams("tag", "SCHOOL", "-");
                    } else {
                      setSchool(true);
                      getSortParams("tag", "SCHOOL", "+");
                    }
                  }}
                >
                  SCHOOL
                </button>
              </li>
            </ul>
          </div>
        )}

        <div
          className="pro-sidebar-search-form"
          action="#"
          style={{
            marginRight: "0px",
            background: "transparent",
            height: "32px",
            border: "1px solid #e6e6e6",
            display: "flex",
            fontSize: "14px",
            minWidth: "143px",
            color: "#606060",
            marginRight: "20px",
            width: "300px",
            marginBottom: "10px",
            width: "100%",
          }}
        >
          <input
            style={{
              marginRight: "0px",
              background: "transparent",
              height: "32px",
              border: "1px solid #e6e6e6",
              fontSize: "14px",
              minWidth: "143px",
              color: "#606060",
            }}
            type="text"
            id="queryTextShopNew"
            placeholder="Cerca qui"
            defaultValue={query || ""}
            onKeyUp={(e) => {
              if (e.key == "Enter") filterProducts();
            }}
          />
          <button
            style={{
              borderColor: "transparent",
              border: "0px",
              backgroundColor: "transparent",
            }}
          >
            <i className="pe-7s-search" onClick={() => filterProducts()} />
          </button>
        </div>

        <div
          className="shop-select"
          style={{ marginBottom: "10px", width: "100%", display: "none" }}
        >
          <select
            onChange={(e) => getFilterSortParams("filterSort", e.target.value)}
          >
            <option value="default">Predefinito</option>
            <option value="priceHighToLow">Prezzo - Decrescente</option>
            <option value="priceLowToHigh">Prezzo - Crescente</option>
          </select>
        </div>

        <div
          className="btn-hover text"
          style={{ marginRight: "20px", width: "100%", display: "flex" }}
        >
          <a
            className="d-block d-lg-none"
            style={{
              padding: "0px",
              height: "32px",
              marginLeft: "0px",
              border: "1px gray solid",
              fontSize: "12px",
              display: "block",
              width: "40%",
              borderColor: "transparent",
              border: "0px",
            }}
            onClick={() => {
              var scrollDiv = document.getElementById("filtri").offsetTop;
              window.scrollTo({ top: scrollDiv, behavior: "smooth" });
            }}
          >
            <i
              className="fa fa-filter fa-2x"
              aria-hidden="true"
              style={{
                color: "white",
                "-webkit-text-stroke": "1px #000",
                " -webkit-text-fill-color": "transparent",
              }}
            ></i>
            &nbsp;Filtra
          </a>
          <a
            style={{
              padding: "0px",
              height: "32px",
              marginLeft: "0px",
              border: "1px gray solid",
              fontSize: "12px",
              display: "block",
              width: "40%",
              borderColor: "transparent",
              border: "0px",
            }}
            onClick={() => resetFiltri()}
          >
            <img
              src="https://dgaplanetshirt.com/assets/img/icon-img/trash-can.png"
              width="16px"
              height="16px"
              style={{ marginRight: "10px" }}
            />
            Resetta filtri
          </a>
        </div>
        {global.aziendaID == 1 && (
          <ul>
            <li key={1}>
              <button
                className={outlet ? "active" : ""}
                style={{
                  border: "none",
                  backgroundColor: outlet ? "#2e98f0" : "red",
                  color: outlet ? "white" : "white",
                  borderRadius: "50px",
                }}
                onClick={(e) => {
                  localStorage.setItem("currentPage", 1);
                  if (outlet) {
                    setOutlet(false);
                    getSortParams("tag", "OUTLET", "-");
                  } else {
                    setOutlet(true);
                    getSortParams("tag", "OUTLET", "+");
                  }
                }}
              >
                <img
                  src="https://dgaplanetshirt.com/assets/img/icon-img/outlet2.svg"
                  width="70px"
                  height="25px"
                />
              </button>
            </li>
          </ul>
        )}
        {global.aziendaID == 2 &&
          userData.user.user?.showPromo == 1 &&
          !sortValues?.tag &&
          false && (
            <ul>
              <li key={1}>
                <button
                  className={promo ? "active" : ""}
                  style={{
                    border: "none",
                    backgroundColor: promo ? "#2e98f0" : "red",
                    color: promo ? "white" : "white",
                    borderRadius: "50px",
                  }}
                  onClick={(e) => {
                    localStorage.setItem("currentPage", 1);
                    if (promo) {
                      setPromo(false);
                      getSortParams("promo", "NO", "+");
                      //getSortParams("tag", "OUTLET", "-");
                    } else {
                      setPromo(true);
                      getSortParams("promo", "SI", "+");
                      //getSortParams("tag", "OUTLET", "+");
                    }
                  }}
                >
                  <span>PROMO</span>
                </button>
              </li>
            </ul>
          )}
        {/*<p>
          Visualizzati {sortedProductCount + offset} di {productCount} totali
  </p>*/}
      </div>

      <div className="shop-tab" style={{ display: "none" }}>
        <button
          onClick={(e) => {
            getLayout("grid two-column");
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-th-large" />
        </button>
        <button
          onClick={(e) => {
            getLayout("grid three-column");
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-th" />
        </button>
        <button
          onClick={(e) => {
            getLayout("list");
            setActiveLayout(e);
          }}
        >
          <i className="fa fa-list-ul" />
        </button>
      </div>
    </div>
  );
};

ShopTopAction.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number,
};

export default ShopTopAction;
